<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <NavBar></NavBar>
        <div class="container-fluid InfoTable">
            <div class="d-flex p-2">
                <div class="InfoTableLeft">帳號</div>
                <div >{{InfoObject.StudentUserId}}</div>
            </div>
            <div class="d-flex p-2">
                <div class="InfoTableLeft">中文姓名</div>
                <input type="text" v-model="InfoObject.StudentName" />
            </div>
            <div class="d-flex p-2">
                <div class="InfoTableLeft">英文姓名</div>
                <input type="text"  v-model="InfoObject.EnglishName"/>
            </div>
            <div class="d-flex p-2">
                <div class="InfoTableLeft">個人通訊信箱</div>
                <input type="text" size="40" v-model="InfoObject.NoticeMail"/>
            </div>
            <div class="d-flex p-2" v-if="false">
                <div class="InfoTableLeft">爸爸通訊信箱</div>
                <input type="text" size="40" v-model="InfoObject.DadEmail" />
            </div>
            <div class="d-flex p-2" v-if="false">
                <div class="InfoTableLeft">媽媽通訊信箱</div>
                <input type="text" size="40" v-model="InfoObject.MomEmail" />
            </div>
        </div>
        <div class="d-flex justify-content-end p-2 mt-2 footerNAV">
            <!--<button class="ShareBTN"><router-link :to="`/index`">取消訂課</router-link></button>-->
            <button class="ShareBTN" @click="SaveProfile()">儲存</button>
            
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'PersonalInfo',
    components:{
        NavBar
    },
    data () {
        return {
            InfoObject:{},
            Token:'',
            showLoading:false,
        }
    },
    methods:{
        getPersionalInfoData(){
            this.showLoading = true;
            //Axios
            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/Student/LoginStudentCenter`;
            // var data={}
            axios.post(api, {}, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        this.InfoObject = response.data;
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }else{
                            alert("個人資料讀取失敗：" + response.data.Message);
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        SaveProfile(){
            if(sessionStorage.getItem('CustomerCode') == '1099'){
                var confirmCancel = confirm("此修改會同步政龍學生管理系統，請確認是否修改")
                if(confirmCancel){
                    this.UpdateStudentProfile();
                }
            }else{
                this.UpdateStudentProfile()
            }
        },
        UpdateStudentProfile(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/UpdateStudentProfile`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = 
            {
                "StudentName": this.InfoObject.StudentName,
                "EnglishName": this.InfoObject.EnglishName,
                "MailObjects": {
                    "EmailType": 2, //自己mail
                    "Email": this.InfoObject.NoticeMail,
                },
                // {
                //     "EmailType": 0, //爸爸mail
                //     "Email": this.InfoObject.DadMail,
                // },
                // {
                //     "EmailType": 1, //媽媽mail
                //     "Email": this.InfoObject.MomMail,
                // }
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        alert("儲存成功！")
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("儲存失敗！閒置時間過長，請重新進入。");
                        }else{
                            alert("儲存失敗！" + response.data.Message)
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("儲存失敗！"+ error.message);
                });
        }
    },    
    created(){
        this.Token = sessionStorage.getItem('Token');
        this.getPersionalInfoData();
    }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/PersonalInfo.vue